module.exports = __webpack_public_path__ + "media/03_hirenka.fe22eb90.mp3";